/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BackendLocalizationResponse,
  LocalizationRequest,
  LocalizationResponse,
  V1LocalizationsBackendDetailError,
  V1LocalizationsBackendUpdateError,
  V1LocalizationsFrontendDetailError,
  V1LocalizationsFrontendUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Localizations<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Localizations
   * @name V1LocalizationsFrontendUpdate
   * @request PUT:/api/v1/localizations/frontend/{cultureName}
   * @secure
   * @response `200` `(LocalizationResponse)[]` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1LocalizationsFrontendUpdate = (
    cultureName: string,
    data: LocalizationRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<LocalizationResponse[], V1LocalizationsFrontendUpdateError>({
      path: `/api/v1/localizations/frontend/${cultureName}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Localizations
   * @name V1LocalizationsFrontendDetail
   * @request GET:/api/v1/localizations/frontend/{cultureName}
   * @secure
   * @response `200` `(LocalizationResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1LocalizationsFrontendDetail = (cultureName: string, params: RequestParams = {}) =>
    this.http.request<LocalizationResponse[], V1LocalizationsFrontendDetailError>({
      path: `/api/v1/localizations/frontend/${cultureName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Localizations
   * @name V1LocalizationsBackendUpdate
   * @request PUT:/api/v1/localizations/backend/{cultureName}
   * @secure
   * @response `200` `(LocalizationResponse)[]` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1LocalizationsBackendUpdate = (
    cultureName: string,
    data: LocalizationRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<LocalizationResponse[], V1LocalizationsBackendUpdateError>({
      path: `/api/v1/localizations/backend/${cultureName}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Localizations
   * @name V1LocalizationsBackendDetail
   * @request GET:/api/v1/localizations/backend/{cultureName}
   * @secure
   * @response `200` `(BackendLocalizationResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1LocalizationsBackendDetail = (cultureName: string, params: RequestParams = {}) =>
    this.http.request<BackendLocalizationResponse[], V1LocalizationsBackendDetailError>({
      path: `/api/v1/localizations/backend/${cultureName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
